import { apiToken, getRoles } from "../config"

export const getAllRole = async () => {
    try {
        const response = await fetch(getRoles, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
              },
        })
        const res = await response.json();
        if(!response.ok) {
            throw new Error(res.message || "Network response was not ok");
        }
        return res;
    } catch(e) {
        throw new Error(e.message || "Failed")
    }
}